import { IAppointment } from '@/service/types'
import dayjs from 'dayjs'

export const formatHours = (time: string) => dayjs(time).format('HH:mm')

export const getInterval = (startDate: string, endDate: string) =>
  `${formatHours(startDate)} - ${formatHours(endDate)}`

export const getExpiresAt = (expiresAt: string) => {
  const totalSeconds = dayjs().diff(expiresAt, 'seconds') * -1
  const remainingMinutes = Math.floor(totalSeconds / 60)
  const remainingSeconds = Math.floor(totalSeconds - remainingMinutes * 60)

  // in case of 0-9: display 01, 02, 03, ... , 09 instead
  const formattedSeconds = remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds

  // if it has been expired, but the server didn't send update, then display 0:00
  const hasNotExpired = remainingMinutes > 0 || (remainingMinutes === 0 && remainingSeconds > 0)

  return hasNotExpired ? `(${remainingMinutes}:${formattedSeconds})` : '(0:00)'
}

export const renderButtonContent = (
  data: Pick<IAppointment, 'startDate' | 'endDate' | 'expiresAt'>,
) => {
  const { startDate, endDate, expiresAt } = data
  const interval = getInterval(startDate, endDate)

  let remainingTime = ''
  if (expiresAt) {
    const totalSeconds = dayjs().diff(expiresAt, 'seconds') * -1
    const remainingMinutes = Math.floor(totalSeconds / 60)
    const remainingSeconds = Math.floor(totalSeconds - remainingMinutes * 60)

    // in case of 0-9: display 01, 02, 03, ... , 09 instead
    const formattedSeconds = remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds

    // if it has been expired, but the server didn't send update, then display 0:00
    const hasNotExpired = remainingMinutes > 0 || (remainingMinutes === 0 && remainingSeconds > 0)

    remainingTime = hasNotExpired ? `(${remainingMinutes}:${formattedSeconds})` : '(0:00)'
  }

  return `${interval} ${remainingTime}`
}

export const formatBirthdayDate = (date: any) => {
  try {
    return date ? dayjs(date).format('YYYY-MM-DD') : ''
  } catch (e) {
    console.error(e)
    return ''
  }
}
